import { render, staticRenderFns } from "./cart-list.vue?vue&type=template&id=639a12da&scoped=true"
import script from "./cart-list.vue?vue&type=script&lang=js"
export * from "./cart-list.vue?vue&type=script&lang=js"
import style0 from "./cart-list.vue?vue&type=style&index=0&id=639a12da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639a12da",
  null
  
)

export default component.exports